module.exports = __webpack_public_path__ + "fonts/Roboto-VariableFont_wdth,wght.86ae1bc.woff2";